import React, { Component } from 'react';
import './App.css';
import Projector from './Projector';
import { ID } from './Utils';

class App extends Component {
  constructor(props) {
    super(props);
    this.key = props.key;

    var projectors = [];
    var projectorState = localStorage.getItem("projectorState");

    if(projectorState === null)
      projectors.push({key: ID()});
    else
      projectors.push({key: ID(), state: JSON.parse(localStorage.getItem("projectorState"))});

    this.state = {
      projectors
    }
  }

  render() {
    return (
      <div className="App">
        <header>
          <h1>
            &nbsp;SaasCake
          </h1>
        </header>
        <div className="App-intro">
          {this.state.projectors.map((projector) => (
              <Projector height={projector.height} key={projector.key} id={projector.key} state={projector.state} />
            ))
          }
        </div>
        <footer>
              &copy; 2017 - {new Date().getFullYear()}, <a rel="noopener noreferrer" target="_blank" href="https://www.twitter.com/@tbirand">Turgay Birand</a>
              <br/>All rights reserved and so on and so forth.
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js